import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Companies from './views/Companies.vue'
import Dashboard from './views/Dashboard.vue'
import Challenge from './views/Challenge.vue'
import Submit from './views/Submit.vue'
import Upload from './views/Upload.vue'
import Apply from './views/Apply.vue'
import Details from './views/Details.vue'
import Applied from './views/Applied.vue'
import Submitted from './views/Submitted.vue'
import Profile from './views/Profile.vue'
import EditProfile from './views/EditProfile.vue'
import Results from './views/Results.vue'
import CompanyContact from './views/CompanyContact.vue'
import ApplyChallenge from './views/ApplyChallenge.vue'
import ApplySubmit from './views/ApplySubmit.vue'
import ApplySubmitted from './views/ApplySubmitted.vue'
import Jobs from './views/Jobs.vue'
import Learn from './views/Learn.vue'
import Practice from './views/Practice.vue'
import LearnDashboard from './views/LearnDashboard.vue'
import PracticeDashboard from './views/PracticeDashboard.vue'
import LearnUIUXDashboard from './views/LearnUIUXDashboard.vue'
import Quiz from './views/Quiz.vue'
import QuizStart from './components/QuizStart.vue'
import QuizEnded from './views/QuizEnded.vue'
import LearnConcepts from './components/LearnConcepts.vue'
import StartLearning from './views/StartLearning.vue'
import Admin from './views/Admin.vue'
import CourseCMS from './views/CourseCMS.vue'
import PathPage from './views/PathPage.vue'
import Assess from './views/Assess.vue'



Vue.use(Router)

let router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return {x:0, y:0};
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: (to, from, next) => {
        if (localStorage.token !== "null" && localStorage.getItem("token") !== null) {
          next('/home');
        } else {
          next();
        }
      }
    },
    {
      path: '/home',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/home/jobs',
      name: 'jobs',
      component: Jobs,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/challenge/:slug',
      name: 'challenge',
      component: Challenge,
      props: true,
      meta: {
        requiresAuth: true
      },
      beforeUpdate: (to, from, next) => {
        if (localStorage.getItem("token") === "null") {
          next('/home');
        } else {
          next();
        }
      }
    },
    {
      path: '/home/quiz/:slug',
      name: 'quiz',
      component: Quiz,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/quiz/:slug/start',
      name: 'quiz-start',
      component: QuizStart,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/quiz/:slug/start/done',
      name: 'quiz-ended',
      component: QuizEnded,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/challenge/:slug/results',
      name: 'results',
      component: Results,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/challenge/:slug/voting',
      name: 'results',
      component: Results,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/apply/:slug',
      name: 'apply',
      component: Apply,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/apply/:slug/details',
      name: 'details',
      component: Details,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/apply/:slug/details/applied',
      name: 'applied',
      component: Applied,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/apply/:slug/challenge',
      name: 'applychallenge',
      component: ApplyChallenge,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/apply/:slug/challenge/submit-work',
      name: 'applySubmit',
      component: ApplySubmit,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/apply/:slug/challenge/submit-work/submitted',
      name: 'applySubmitted',
      component: ApplySubmitted,
      props: true,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/home/challenge/:slug/submit-work/submitted',
      name: 'submitted',
      component: Submitted,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard',
      name: 'profile',
      component: Profile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard/update',
      name: 'edit-profile',
      component: EditProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/upload/post',
      name: 'upload',
      component: Upload,
      props: true
    },
    {
      path: '/home/challenge/:slug/submit-work',
      name: 'submit-work',
      props: true,
      component: Submit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/companies',
      name: 'companies',
      component: Companies
    },
    {
      path: '/companies/get-in-touch',
      name: 'companycontact',
      component: CompanyContact
    },
    {
      path: '/get-in-touch',
      name: 'company-contact',
      component: CompanyContact
    },
    {
      path: '/learn',
      name: 'learn',
      component: Learn
    },
    {
      path: '/pp-admin',
      name: 'pp-admin',
      component: Admin
    },
    {
      path: '/practice',
      name: 'practice',
      component: Practice
    },
    {
      path: '/custom-path',
      name: 'custom-path',
      component: PathPage

    },
    {
      path: '/assess', 
      name: 'assess',
      component: Assess
    },
    {
      path: '/home/learn',
      name: 'learndashboard',
      component: LearnDashboard,
      meta: {
        requiresAuth: true
      }
    }, 
    {
      path: '/home/learn/learn-ui-ux',
      name: 'learn-ui-ux',
      component: LearnUIUXDashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/practice',
      name: 'practice-dashboard',
      component: PracticeDashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/learn/:slug',
      name: 'learn-concepts',
      component: LearnConcepts,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/learn/:slug/start-learning/:topic',
      name: 'start-learning',
      component: StartLearning,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/learn/:slug/start-learning',
      name: 'start-learning',
      component: StartLearning,
      meta: {
        requiresAuth: true
      }

    },
    {
      path: '/home/practice/:skill',
      name: 'quiz',
      component: Quiz,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/practice/:skill/start',
      name: 'quiz-start',
      component: QuizStart,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/practice/:skill/done',
      name: 'quiz-ended',
      component: QuizEnded,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/internal/course',
      name: 'course-cms',
      component: CourseCMS,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem("token") === "null") {
      next({
        path: '/home'
      });
    } else {
        next();
    }
  } else {
    next();
  }
});

export default router